import { SET_DIALOG_HANDLE, SET_DIALOG_HANDLE_IS_OPEN, SET_CAN_CLOSE_DIALOG, SET_DIALOG_TITLE, SET_DIALOG_CHANGED, SET_MULTI_DIALOG_CHANGED } from "../const"
import { IDialogChildComponent, IDialogHandleState } from "../reducers/dialog"


export function setDialogHandle<T extends IDialogChildComponent>(modalState: Partial<IDialogHandleState<T>>) {
    return {
        type: SET_DIALOG_HANDLE,
        payload: modalState
    }
}

export function setIsDialogOpen(isOpen: boolean) {
    return {
        type: SET_DIALOG_HANDLE_IS_OPEN,
        payload: isOpen
    }
}
export function setCanCloseDialog(canClose: boolean) {
    return {
        type: SET_CAN_CLOSE_DIALOG,
        payload: canClose
    }
}

export function setDialogTitle(title: string | undefined) {
    return {
        type: SET_DIALOG_TITLE,
        payload: title
    }
}

export function setDialogChanged(isChanged: boolean) {
    return {
        type: SET_DIALOG_CHANGED,
        payload: isChanged
    }
}

export function setMultiDialogChanged(isChanged: boolean) {
    return {
        type: SET_MULTI_DIALOG_CHANGED,
        payload: isChanged
    }
}